import { useState } from 'react'
import React from 'react'
import axios from 'axios'
import './stock.css' // 引用全局样式文件

export default function Stock({ symbols }) {
  const [data, setData] = useState([])

  const fetchData = async (symbolValue) => {
    try {
      const result = await axios(`stock?symbol=${symbolValue}`);
      setData(result.data)
    } catch (error) {
      console.log(error)
    }
  };
  
  React.useEffect(() => {
    const symbolString = symbols.join(',');
    fetchData(symbolString);
    const intervalId = setInterval(() => {
      fetchData(symbolString);
    }, 1000 * 3);
    return () => clearInterval(intervalId);
  }, [symbols]);

  return (
    <table className="gray margin-top-xs" cellSpacing="10">
      <tbody>
      {
        data.map((item, index) => (
          <tr key={item.symbol}>
            <td>{ item.symbol }</td>
            <td>|</td>
            <td style={{color: '#f60'}}>{ item.current }</td>
            <td>|</td>
            <td>{ item.percent }%</td>
          </tr>
        ))
      }
      </tbody>
    </table>
  )
}
